export function validateText(text) {
  return text.trim().length > 0;
}

export function validateEmail(email) {
  const pattern = /^(([^<>()\[\]\\.,;:\s@']+(\.[^<>()\[\]\\.,;:\s@']+)*)|('.+'))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

  return validateText(email) && pattern.test(email);
}

export function validateZip(zip) {
  const pattern = /(^\{5}$)|(^\d{5}$)/;

  return validateText(zip) && pattern.test(zip);
}



// WEBPACK FOOTER //
// ./src/client/helpers/utilities/validators.js